/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_mobile_analytics_app_id": "2af4fa525e59480193b868e184d93bfa",
    "aws_mobile_analytics_app_region": "us-west-2",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "2af4fa525e59480193b868e184d93bfa",
            "region": "us-west-2"
        }
    },
    "aws_appsync_graphqlEndpoint": "https://q767yci7fjclhkcjgiwaywygru.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-mphdv2f4rfctfohrrzniklm4ta",
    "aws_cloud_logic_custom": [
        {
            "name": "payment",
            "endpoint": "https://moex23qru0.execute-api.ap-northeast-1.amazonaws.com/sl",
            "region": "ap-northeast-1"
        }
    ],
    "aws_cognito_identity_pool_id": "ap-northeast-1:fabb5ef7-bb77-4355-b5bd-201243737971",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_kpOlmkpdg",
    "aws_user_pools_web_client_id": "11mckor5cjrhq12segup6sqe3l",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "antecessor02735-sl",
    "aws_user_files_s3_bucket_region": "ap-northeast-1"
};


export default awsmobile;
